import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import getStripe from "../stripe";
import { RootState } from "../redux/root-store";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCheckoutSession } from "../firebase";
import { CircularProgress } from "@mui/material";
import Confirm from "../components/confirm";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Container = styled.div`
    width: 100vw;
    height: 100vh;
`;

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

interface Props extends ReturnType<typeof mapStateToProps> {}

const ValidateCheckout = (props: Props) => {
    const query = useQuery();
    const { loggedUser } = props;
    const navigate = useNavigate();
    const [purchasedPlan, setPurchasedPlan] = useState<string>("");
    const [validateComplete, setValidateComplete] = useState<boolean>(false);
    const [failed, setFailed] = useState<boolean>(false);

    const handleValidateCheckout = async (sessionId: string) => {
        if (!sessionId) return;
        try {
            const a = await fetchCheckoutSession(sessionId);
            if (a.itemList?.data.length) {
                setPurchasedPlan(a.itemList?.data[0].description);
            }
            setValidateComplete(true);
        } catch (e) {
            // setFailed(true);
        }
    };
    useEffect(() => {
        handleValidateCheckout(query.get("session_id") || "");
    }, []);

    if (!loggedUser) return null;
    return (
        <Container>
            <div
                style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress />
            </div>
            {validateComplete && (
                <Confirm
                    open={true}
                    text={`Congrats, you are now on the ${purchasedPlan} plan.`}
                    confirmText="Awesome"
                    cancelText=" "
                    onConfirm={() => navigate("/contacts")}
                />
            )}
            {failed && (
                <Confirm
                    open={true}
                    text={`Something went wrong`}
                    confirmText="OK"
                    cancelText=" "
                    onConfirm={() => navigate("/contacts")}
                />
            )}
        </Container>
    );
};

export default connect(mapStateToProps, {})(ValidateCheckout);
